import { AsyncActionState } from '@telstra-connect/standard-actions/async-action'
import { IOpsHubState } from '.'
export const initialState: IOpsHubState = {
  customerProps: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  updateCustomerProps: {
    status: AsyncActionState.NotStarted,
  },
  customerCustomProps: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  userCustomProps: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  updateCustomerCustomProps: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  updateUserCustomProps: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  userCidnAssociation: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  removeUserCidnAssociation: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  userDetails: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  updateUserDetails: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  updateUserStatus: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  userServices: {
    status: AsyncActionState.NotStarted,
    data: null
  },
  updateUserService: {
    status: AsyncActionState.NotStarted,
    data: null
  }

}
